import script from "./RegisterComplete.vue?vue&type=script&setup=true&name=join_RegisterCOmplete&lang=js"
export * from "./RegisterComplete.vue?vue&type=script&setup=true&name=join_RegisterCOmplete&lang=js"

const __exports__ = script;

export default __exports__